import { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { BudgetProposalT, CadrageT } from 'routes/BudgetModule/config/types';
import { createBudgetQueryKeys } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { useCadrageQuery } from 'routes/BudgetModule/helpers/hooks/useCustomQuery';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

const getCadrageDataEndpoint = (
    budget_proposal_id: number,
    budgetLineCode?: string,
): string => {
    let endpoint = `budget/cadrage/details/${budget_proposal_id}`;
    if (budgetLineCode) {
        endpoint += `?budget_line_code=${budgetLineCode}`;
    }
    return endpoint;
};

/**
 * Hooks that returns a list of cadrage's values for a given budget proposal, for each gest or serv.
 *
 * It returns either the values stored in the property budgetProposal.cadrage,
 * or if it's empty, it fetches the amount spent 2 or 3 years ago (depending on the client)
 * for each gest or serv.
 *
 * BudgetLineCode is only used for SIFAC.
 */
export const useGetCadrageData = (
    budgetProposal: BudgetProposalT,
    budgetLineCode?: string,
    params?: Pick<UseQueryOptions<CadrageT[], HttpError>, 'enabled'>,
): UseQueryResult<CadrageT[], HttpError> => {
    const { cadrageKeys } = createBudgetQueryKeys();
    return useCadrageQuery<CadrageT[], HttpError>(
        cadrageKeys({
            exercice: budgetProposal.exercice,
            budgetProposalId: budgetProposal.id,
            budgetLineCode: budgetLineCode,
        }),
        async () => {
            const response = await RQAPICallWithData<CadrageT[]>({
                endpoint: getCadrageDataEndpoint(
                    budgetProposal.id,
                    budgetLineCode,
                ),
                method: 'GET',
            });
            return response.content.data;
        },
        params,
    );
};
